import { icons } from 'src/assets/iconDef/icon.def';

export const mrdMenuDef = [
  {
    "name": "mrd_library",
    "resource": "mrd_library",
    "view": "mrd_library",
    "icon": "fa fa-tag",
    "url": "mrd_library",
    "breadcrumb": "Mrd library",
    "auto_crud": true,
    "showMenu":false
  },
  {
    "name": "Send Discharged Files",
    "resource": "files_format",
    "view": "files_format",
    "icon": "fa fa-tag",
    "url": "files_format",
    "breadcrumb": "files_format",
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "Send Discharged Files",
    "resource": "mrd_sentFiles",
    "view": "mrd_sentFiles",
    "icon": "fa fa-tag",
    "url": "mrd_sentFiles",
    "breadcrumb": "mrd_sentFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "mrd_rejectedFiles",
    "view": "mrd_rejectedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_rejectedFiles",
    "breadcrumb": "mrd_rejectedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "mrd_completedFiles",
    "view": "mrd_completedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_completedFiles",
    "breadcrumb": "mrd_completedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "mrd_approveFiles",
    "view": "mrd_approveFiles",
    "icon": "fa fa-tag",
    "url": "mrd_approveFiles",
    "breadcrumb": "mrd_approveFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "mrd_rejectedReceivedFiles",
    "view": "mrd_rejectedReceivedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_rejectedReceivedFiles",
    "breadcrumb": "mrd_rejectedReceivedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "mrd_completedReceivedFiles",
    "view": "mrd_completedReceivedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_completedReceivedFiles",
    "breadcrumb": "mrd_completedReceivedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Received Files",
    "resource": "received_files_format",
    "view": "received_files_format",
    "icon": "fa fa-tag",
    "url": "received_files_format",
    "breadcrumb": "received_files_format",
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "Request Files",
    "resource": "request_format",
    "view": "request_format",
    "icon": "fa fa-tag",
    "url": "request_format",
    "breadcrumb": "request_format",
    "auto_crud": true,
    "showMenu": true
  },
 
  {
    "name": "Issue Files",
    "resource": "issued_format",
    "view": "issued_format",
    "icon": "fa fa-tag",
    "url": "issued_format",
    "breadcrumb": "issued_format",
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "Direct Issue Files",
    "resource": "directIssue_format",
    "view": "directIssue_format",
    "icon": "fa fa-tag",
    "url": "directIssue_format",
    "breadcrumb": "directIssue_format",
    "auto_crud": true,
    "showMenu": true
  },
  {
    "name": "mrd_issueFiles",
    "resource": "mrd_issueFiles",
    "view": "mrd_issueFiles",
    "icon": "fa fa-tag",
    "url": "mrd_issueFiles",
    "breadcrumb": "mrd_issueFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "mrd_returnedFiles",
    "resource": "mrd_returnedFiles",
    "view": "mrd_returnedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_returnedFiles",
    "breadcrumb": "mrd_returnedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "mrd_issuedFiles",
    "resource": "mrd_issuedFiles",
    "view": "mrd_issuedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_issuedFiles",
    "breadcrumb": "mrd_issuedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "mrd_receivedFiles",
    "resource": "mrd_receivedFiles",
    "view": "mrd_receivedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_receivedFiles",
    "breadcrumb": "mrd_receivedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "rejected_files",
    "resource": "rejected_files",
    "view": "rejected_files",
    "icon": "fa fa-tag",
    "url": "rejected_files",
    "breadcrumb": "rejected_files",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "mrd_request",
    "resource": "mrd_request",
    "view": "mrd_request",
    "icon": "fa fa-tag",
    "url": "mrd_request",
    "breadcrumb": "mrd_request",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "pending_files",
    "view": "pending_files",
    "icon": "fa fa-tag",
    "url": "pending_files",
    "breadcrumb": "pending_files",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "issued_files",
    "view": "issued_files",
    "icon": "fa fa-tag",
    "url": "issued_files",
    "breadcrumb": "issued_files",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "requested_files",
    "view": "requested_files",
    "icon": "fa fa-tag",
    "url": "requested_files",
    "breadcrumb": "requested_files",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Send Discharged Files",
    "resource": "returned_files",
    "view": "returned_files",
    "icon": "fa fa-tag",
    "url": "returned_files",
    "breadcrumb": "returned_files",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Issue",
    "resource": "mrd_directIssue",
    "view": "mrd_directIssue",
    "icon": "fa fa-tag",
    "url": "mrd_directIssue",
    "breadcrumb": "mrd_directIssue",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Issue",
    "resource": "mrd_directIssuedfiles",
    "view": "mrd_directIssuedfiles",
    "icon": "fa fa-tag",
    "url": "mrd_directIssuedfiles",
    "breadcrumb": "mrd_directIssuedfiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Issue",
    "resource": "mrd_directIssueUpdate",
    "view": "mrd_directIssueUpdate",
    "icon": "fa fa-tag",
    "url": "mrd_directIssueUpdate",
    "breadcrumb": "mrd_directIssueUpdate",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Received",
    "resource": "mrd_directReceivedFiles",
    "view": "mrd_directReceivedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_directReceivedFiles",
    "breadcrumb": "mrd_directReceivedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Received",
    "resource": "mrd_issueRequestFiles",
    "view": "mrd_issueRequestFiles",
    "icon": "fa fa-tag",
    "url": "mrd_issueRequestFiles",
    "breadcrumb": "mrd_issueRequestFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Received",
    "resource": "mrd_returnIssuedFiles",
    "view": "mrd_returnIssuedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_returnIssuedFiles",
    "breadcrumb": "mrd_returnIssuedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Received",
    "resource": "mrd_receiveReturnedFiles",
    "view": "mrd_receiveReturnedFiles",
    "icon": "fa fa-tag",
    "url": "mrd_receiveReturnedFiles",
    "breadcrumb": "mrd_receiveReturnedFiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Received",
    "resource": "mrd_ackIssuedfiles",
    "view": "mrd_ackIssuedfiles",
    "icon": "fa fa-tag",
    "url": "mrd_ackIssuedfiles",
    "breadcrumb": "mrd_ackIssuedfiles",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": "Direct Received",
    "resource": "acknowledged_files",
    "view": "acknowledged_files",
    "icon": "fa fa-tag",
    "url": "acknowledged_files",
    "breadcrumb": "acknowledged_files",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "resource": "mrd_op_file_list",
    "url": "mrd_op_file_list",
    "auto_crud": true,
    "showMenu": false
  },
  {
    "name": 'menu.mrd_checklist',
    "resource":"mrd_checklist",
    "icon": 'fa fa-h-square',
    "url": 'mrd_checklist',
    "breadcrumb": "mrd_checklist",
    "auto_crud": true
  },
  {
    "name": "menu.mark_confidential",
    "resource": "emr_confidentiality",
    "icon": "fa fa-tag",
    "url": "emr_confidentiality",
    "breadcrumb": "emr/emr_confidentiality",
    "auto_crud": true,
    "showMenu": true
  }
]

